<template>
    <b-card title="Atividades Recentes" style="min-height: 473px">
        <loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center px-0" v-for="audit in audits"
                :key="audit.id">
                <span>
                    <b>{{ audit.event }}</b>
                    <br />
                    <small class="text-muted" style="font-size: 10px">
                        <i class="fas fa-history"></i>
                        {{ audit.type }} - <i class="far fa-clock"></i>
                        {{ audit.created_at | moment("from", "now", true) }}
                    </small>
                </span>
                <b-popover :target="'popover-target-' + audit.id" triggers="hover" placement="top">
                    <pre v-html="audit.new_values"></pre>
                </b-popover>
                <small class="text-muted">
                    <b-button :id="'popover-target-' + audit.id" variant="default" size="xs" style="border: 0">
                        <i class="fas fa-ellipsis-v"></i>
                    </b-button>
                </small>
            </b-list-group-item>
        </b-list-group>
    </b-card>
</template>
<script>
export default { props: ['loading', 'audits'] }

</script>